import React,{useState, useEffect} from 'react';
import Modal from '@material-ui/core/Modal';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import {Tools} from './Tools';
import CancelIcon from '@material-ui/icons/Cancel';
import './Archive.scss';

interface Props {
    next():void,
}

let tid1:NodeJS.Timeout;
let tid2:NodeJS.Timeout;

const Greeting = (props:Props)=> {
    const [count,setCount] = useState(3);
    const next = ()=>{
        clearTimeout(tid1);
        clearTimeout(tid2);
        props.next();
    }
    useEffect( ()=>{
        tid1 = setTimeout( ()=>{
            setCount(count-1);
        },1000);
        return ()=>{
            clearTimeout(tid1);
        }
    },[count]);

    if( count===0 ){
        tid2 = setTimeout( ()=>{
            props.next();
        },100);
    }

    return (
        <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={true}
            onClose={props.next}
        >
            <div style={Tools.getModalStyle()} className="alert">
                <div className="dialogRoot">
                    <div style={{marginBottom:"1em"}}>
                        こえにだしてよみませう<br/>
                        げんきなこえでよみませう<br/>
                    </div>
                    <div style={{marginBottom:"1em",textAlign:"center",fontSize:"180%",fontWeight:"bold"}}>
                        {count}
                    </div>
                    <Tooltip title="スタート"><Button variant="contained" color="secondary" style={{width:"100%"}} onClick={next}>スタート</Button></Tooltip>
                    <IconButton aria-label="close" onClick={props.next} color="primary" style={{position:"absolute",top:"-0.3em",right:"-0.3em"}}>
                        <CancelIcon/>
                    </IconButton>
                </div>
            </div>
        </Modal>
	);
}

export default Greeting;